module.exports = __webpack_public_path__ + "assets/media/m2_1.ee3abf05.mp4";